import PolygonBase from './PolygonBase';
import shapeIcon from '../assets/icons/shapeOffpageConnector.svg';
import { svgToIcon } from '../utils/svg';

const HEIGHT_FACTOR = 0.75;

class ShapeOffpageConnector extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeIcon);
  }

  static defaultHeight() {
    return this.defaultWidth() * HEIGHT_FACTOR;
  }

  static pathString() {
    return `
      M -0.5 -0.5
      L 0.5 -0.5
      L 0.5 0.0
      L 0.0 0.5
      L -0.5 0.0
      Z
    `;
  }

  calcTextMargin() {
    const margins = super.calcTextMargin();
    margins.bottom += 20;
    return margins;
  }
}

export default ShapeOffpageConnector;
